import '../../App.scss';
import pseuds from '../../data/pseuds.json'

export default function Blurbs(props) {

	const reviewer1 = props.reviewer1;
	var rev1;
	var blurb1 = ""
	rev1 = reviewer1.yourPseudonym ? reviewer1.yourPseudonym : reviewer1.tagger
	for (var p of pseuds.pseuds) {
		if (p[0] === rev1) 
			rev1 = p[1];
	}
	if (reviewer1.copyEditedBlurb && reviewer1.copyEditedBlurb !== "") {
		blurb1 = reviewer1.copyEditedBlurb;
	} else if (reviewer1.blurb && reviewer1.blurb !== "") {
		blurb1 = reviewer1.blurb;
	} else {
		blurb1 = "<i>Blurb forthcoming.</i>"
	}

	var rev2 = "<i>Blurb forthcoming.</i>"
	var blurb2 = ""

	if (props.reviewer2) {
		const reviewer2 = props.reviewer2;
		rev2 = reviewer2.yourPseudonym ? reviewer2.yourPseudonym : reviewer2.tagger
		for (var p of pseuds.pseuds) {
			if (p[0] === rev2) 
				rev2 = p[1];
		}
		if (reviewer2.copyEditedBlurb && reviewer2.copyEditedBlurb !== "") {
			blurb2 = reviewer2.copyEditedBlurb;
		} else if (reviewer2.blurb && reviewer2.blurb !== "") {
			blurb2 = reviewer2.blurb;
		} else {
			blurb2 = "<i>Blurb forthcoming.</i>"
		}
	}



    return (
		<div className='align-left section-header white reviews'>
			<h1>Blurb #1</h1>
			<h3>Written by <b>{rev1}</b></h3>
			<p  style={{ whiteSpace: 'pre-wrap' }}
			dangerouslySetInnerHTML={{ __html: blurb1 }}/>

			<br/>
			<br/>
			
			<h1>Blurb #2</h1>
			<h3>Written by <b style={{ whiteSpace: 'pre-wrap' }} 
			dangerouslySetInnerHTML={{ __html: rev2 }}/></h3>
			<p  style={{ whiteSpace: 'pre-wrap' }} 
			dangerouslySetInnerHTML={{ __html: blurb2 }}/>
			
		</div>
    )

}